var React = require('react');

function ShareSingleColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0476 4.42191C5.87645 4.42191 1.36542 7.93921 0.111353 12.9516L0.045166 13.2152C2.86203 10.4011 6.69046 8.81858 10.6738 8.81858H11.0477V13.2152L17.6492 6.62027L11.0477 0.0253296L11.0476 4.42191Z","fill":"#AFB4BD"}));
}

ShareSingleColor.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = ShareSingleColor;

ShareSingleColor.default = ShareSingleColor;
